import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E14220",
      d: "M18.094.516C16.74.204 14.515 0 12 0S7.26.204 5.906.516a6.99 6.99 0 0 0-5.39 5.39C.204 7.26 0 9.485 0 12s.204 4.74.516 6.094a6.99 6.99 0 0 0 5.39 5.39C7.26 23.796 9.485 24 12 24s4.74-.204 6.094-.516a6.99 6.99 0 0 0 5.39-5.39C23.796 16.74 24 14.515 24 12s-.204-4.74-.516-6.094a6.99 6.99 0 0 0-5.39-5.39"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M4.33 6.665a.75.75 0 0 1 1.006-.336l2 1a.75.75 0 1 1-.671 1.342l-2-1a.75.75 0 0 1-.336-1.006m15.341 0a.75.75 0 0 1-.335 1.006l-2 1a.75.75 0 1 1-.67-1.342l2-1a.75.75 0 0 1 1.006.336",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement("circle", { cx: 6, cy: 8, r: 1, fill: "#fff" }),
  /* @__PURE__ */ React.createElement("circle", { cx: 18, cy: 8, r: 1, fill: "#fff" }),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M15.482 12.542q-.003 0-.008-.006a1 1 0 0 0-.093-.068 3 3 0 0 0-.534-.272c-.527-.21-1.431-.446-2.847-.446s-2.32.236-2.846.446a3 3 0 0 0-.535.272q-.073.049-.093.068l-.008.006A.75.75 0 0 1 7.47 11.47l.514.514-.514-.515h.001l.002-.003.004-.003.008-.009a1 1 0 0 1 .087-.076q.077-.066.215-.158c.184-.123.449-.272.81-.416.723-.29 1.819-.554 3.403-.554s2.68.264 3.403.554c.361.144.626.293.81.416a3 3 0 0 1 .302.234l.008.009.004.003.002.002c0 .001.001.002-.529.532l.53-.53a.75.75 0 0 1-1.048 1.072m-.012-.01.012.01z",
      clipRule: "evenodd"
    }
  )
);
var SvgSentimentNegativeFilled = styled(SvgComponent)`
  ${size}
  ${color}
`;
var SentimentNegativeFilled_default = SvgSentimentNegativeFilled;

export { SentimentNegativeFilled_default as default };
